import { UserSettings } from "@/config/constant";
const createObj = configModel => {
  const model = {};
  Object.keys(configModel).map(x => (model[x] = null));
  return model;
};

export const models = createObj(UserSettings);

export const options = {};

export const Fields = [
  {
    label: "User Settings",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Name",
    name: UserSettings.name,
    placeholder: "Enter your name...",
    type: "text",
    value: "",
    validationMessage: {
      required: "Your name is required",
      min: "Minimum length 5 characters required"
    },
    rules: "required|min:5",
    xl: "8"
  },
  {
    label: "Email",
    name: UserSettings.email,
    placeholder: "Enter your email...",
    type: "email",
    value: "",
    validationMessage: {
      required: "Email is required",
      email: "Enter a valid email address"
    },
    rules: "required|email",
    xl: "8"
  },
  {
    label: "Phone",
    name: UserSettings.phone,
    placeholder: "Enter your phone number...",
    type: "phone",
    value: "",
    // validationMessage: {
    //   required: "Phone number is required"
    // },
    // rules: "required",
    xl: "8"
  },
  {
    label: "",
    name: UserSettings.media,
    placeholder: "Upload your Logo",
    type: "userPhoto",
    multiple: false,
    value: UserSettings.profile_photo_url,
    xl: "8",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Password",
    name: UserSettings.password,
    placeholder: "Enter your Password...",
    type: "password",
    value: "",
    // rules: "required|min:8",
    // validationMessage: {
    //   required: "Password is required",
    //   min: "Minimum length 8 characters required"
    // },
    xl: "8"
  },
  {
    label: "Confirm Password",
    name: UserSettings.password_confirmation,
    placeholder: "Confirm your password...",
    type: "password",
    value: "",
    validationMessage: {
      required: "Please confirm your password",
      match: "Passwords do not match"
    },
    rules: "required_if:" + UserSettings.password + "|confirmed:" + UserSettings.password,
    xl: "8"
  }
];
